import { Icon } from '@iconify/react';
import React, { Component } from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { ToastContainer, toast } from 'react-toastify';
import whitearrow from "../Images/whitearrow.svg";
import 'react-datepicker/dist/react-datepicker.css';
import { checkEmpty, formatDate, formatTime } from '../../GenericFunctions';
import constants from "../../GlobalConstants";
import AnalogTimePicker from './AnalogTimePicker';


class AppointmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: null,
      selectedTime: null
    }
  }

  saveHandler = (e) => {
    e.preventDefault();
    let date = '', time = '';
    this.setState({ spinner: true });
    const { firstName, lastName, phoneNumber, email, address, selectedDate, selectedTime } = this.state;
    if (checkEmpty(firstName)) {
      toast.error('First Name is empty.')
      return;
    }
    if (checkEmpty(phoneNumber) || checkEmpty(email)) {
      toast.error('Phone Number or E-mail is empty.')
      return;
    }
    if (!checkEmpty(selectedDate)) {
      date = formatDate(selectedDate)
    }
    if (!checkEmpty(selectedTime)) {
      time = formatTime(selectedTime)
    }
    const data = {
      location: "10396",
      master: "A",
      userID: "2000733",
      patientWorkAreaVo: {
        demoRequestVo: {
          transNo: "",
          personName: firstName + " " + lastName,
          designation: "HR",
          phoneCode: "IN",
          date: date + ' ' + time,
          phoneNo: phoneNumber,
          emailID: email,
          // locType: this.state.demoFor,
          locName: firstName + " " + lastName,
          locAddress: address,
          status: "",
          createdBy: "",
          createdOn: "",
          delete: "false",
          multiple: "false",
          getDetails: "false",
          skipDetails: "false",
          pagerExcluded: "false",
        },
      },
    };
    // toast.error("Request sent Successfully");
    console.log("saveDemoRequest() data => ", data);
    axios.post(constants.webServiceURL + "/DocChoiceWebServices/patientApp/saveDemoRequest", data)
      .then((resp) => {
        this.setState({ spinner: false });
        console.log("saveDemoRequest() Resp => ", resp);
        const { status } = resp.data;
        if (status === "200") {
          toast.error("Thank you ! Your request has been sent successfully . Redirecting you to the home page ... ");
          setTimeout(function () {
            window.location.href = "/";
          }, 5000);
        }
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ spinner: false });
      });
  }

  txtHandleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleChangeDate = (date) => {
    console.log("fff", formatDate(date))
    this.setState({ selectedDate: date })
  }

  handleChangeTime = (time) => {
    this.setState({ selectedTime: time })
  }

  // const [selectedDate, setSelectedDate] = useState(null);
  render() {
    const { selectedDate, firstName, lastName, email, phoneNumber, address, selectedTime } = this.state;
    return (
      <>
        <style>
          {`
            .cs_with_icon_input .react-datepicker-wrapper {
              width: 100%;
            }
            .cs_with_icon_input .react-datepicker-wrapper input {
              padding-right: 70px !important;
              min-height: 50px;
              display: flex !important;
              align-items: center;
              width: 100% !important;
              box-sizing: border-box;
            }
            .cs_with_icon_input .react-datepicker-wrapper input:focus {
              padding-right: 70px !important;
            }
            .cs_with_icon_input .cs_timepicker {
              padding-right: 70px !important;
              box-sizing: border-box;
            }
            .cs_with_icon_input .react-datepicker-wrapper input[value=""] {
              color: #999;
            }
            .cs_with_icon_input .react-datepicker-wrapper input:not([value=""]) {
              color: inherit;
            }
            .cs_with_icon_input i {
              right: 25px !important;
              left: auto !important;
              top: 50% !important;
              transform: translateY(-50%) !important;
              position: absolute !important;
            }
            @media (max-width: 1700px) {
              .cs_with_icon_input i {
                right: 20px !important;
                left: auto !important;
              }
            }
          `}
        </style>
        <form action="#" className="row" onSubmit={this.saveHandler}>
          {/* <label className="cs_input_label cs_heading_color">Department</label> */}

          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Name</label>
            <input type="text"
              value={firstName}
              name={"firstName"}
              className="cs_form_field"
              placeholder="First Name"
              onChange={this.txtHandleChange} />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Last Name</label>
            <input type="text"
              value={lastName}
              name={"lastName"}
              className="cs_form_field"
              placeholder="Last Name"
              onChange={this.txtHandleChange} />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>

          <div className="col-lg-4">
            <label className="cs_input_label cs_heading_color">Phone Number</label>
            <input
              value={phoneNumber}
              name={"phoneNumber"}
              type="text"
              className="cs_form_field"
              placeholder="(123) 456 - 789"
              onChange={this.txtHandleChange}
            />

            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-8">
            <label className="cs_input_label cs_heading_color">E-mail</label>
            <input type="text"
              value={email}
              name={"email"}
              className="cs_form_field"
              placeholder="abc@gmail.com"
              onChange={this.txtHandleChange} />
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          {/* <div className="col-lg-12">
        <label className="cs_input_label cs_heading_color">Address</label>
        <input type="text" className="cs_form_field" />
        <div className="cs_height_36 cs_height_l_20" />
      </div> */}
          {/* <div className="col-lg-6">
        <label className="cs_input_label cs_heading_color">
          Medical Record Number
        </label>
        <input
          type="text"
          className="cs_form_field"
          placeholder="123456-7890-0987"
        />
        <div className="cs_height_42 cs_height_xl_25" />
      </div> */}
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">
              Preferred Date
            </label>

            <div className="cs_with_icon_input" style={{ position: 'relative' }}>
              <DatePicker
                selected={selectedDate}
                // onChange={date => setSelectedDate(date)}
                dateFormat="dd/MMM/yyyy"
                minDate={new Date()}
                value={selectedDate}
                onChange={this.handleChangeDate}
                placeholderText="dd/mm/yyyy"
                className="cs_form_field"
              />
              <i style={{ pointerEvents: 'none', zIndex: 1, position: 'absolute', right: '25px', top: '50%', transform: 'translateY(-50%)' }}>
                <Icon icon="fa6-solid:calendar-days" />
              </i>
            </div>
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">
              Preferred Time
            </label>
            <div className="cs_with_icon_input" style={{ position: 'relative' }}>
              <AnalogTimePicker
                selectedTime={selectedTime}
                onChange={this.handleChangeTime}
                placeholderText="Select time"
              />
              <i style={{ pointerEvents: 'none', zIndex: 1, position: 'absolute', right: '25px', top: '50%', transform: 'translateY(-50%)' }}>
                <Icon icon="fa6-regular:clock" />
              </i>
            </div>
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Address</label>
            <input type="text"
              value={address}
              name={"address"}
              className="cs_form_field"
              onChange={this.txtHandleChange} />
            <div className="cs_height_36 cs_height_l_20" />
          </div>
          <div className="col-lg-12">
            <button className="cs_btn cs_style_1">
              <span>Submit</span>
              <i>
                <img src={whitearrow} alt="Icon" />
                <img src={whitearrow} alt="Icon" />
              </i>
            </button>
          </div>
        </form>
        <ToastContainer />
      </>
    );
  }
}
export default AppointmentForm;
